import { createContext } from 'react';
import PropTypes from 'prop-types';

export const RichTextContext = createContext();

export const RICH_TEXT_OVERRIDES = [
    'root',
    'editorWrapper',
    'editor',
    'topComponent',
    'bottomComponent',
];

export const richTextPropTypes = {
    className: PropTypes.string,
    /** Error will be displayed below the component with style changes */
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    /** Info will be displayed below the component */
    info: PropTypes.string,
    isFullWidth: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onSubmit: PropTypes.func,
    onEsc: PropTypes.func,
    placeholder: PropTypes.string,
    toolbar: PropTypes.arrayOf(
        PropTypes.shape({
            hint: PropTypes.string,
            item: PropTypes.oneOf(['b', 'i', 'u', 'ol', 'ul', 'del']),
        }),
    ),
    toolbarStyle: PropTypes.oneOf(['floating', 'fixed']),
    /** An HTML string */
    value: PropTypes.string,
    mention: PropTypes.shape({
        /** Fetch suggestions for the mentions feature */
        fetchSuggestions: PropTypes.func,
        /** Tooltip text for the mentions button in the toolbar */
        tooltip: PropTypes.string,
        texts: PropTypes.shape({
            /** Text advice to show at the top of the mentions popover */
            advice: PropTypes.string,
            /** Text to show if the mentions search can't find a match */
            noResults: PropTypes.string,
        }),
        /** Max visible items in the suggestions list */
        maxVisibleItems: PropTypes.number,
    }),
    /** Enable compact mode: 'Single line height' editor with action buttons on the right that expands on focus */
    compactMode: PropTypes.bool,
    /** Enable autofocus */
    autofocus: PropTypes.bool,
    canSubmit: PropTypes.func,
    onChangeFocus: PropTypes.func,
    emoji: PropTypes.shape({
        /** Tooltip text for the mentions button in the toolbar */
        tooltip: PropTypes.string,
        /** Max visible items in the suggestions list */
        maxVisibleItems: PropTypes.number,
    }),
    /** Hide clear action button in the editor's input area */
    hideClear: PropTypes.bool,
    submitTooltip: PropTypes.string,
    /** No toolbar is shown, no emoji tool, just the text box and Submit button on the right */
    isBasic: PropTypes.bool,
    basicType: PropTypes.oneOf(['static', 'dynamic']),
    /** In basic richtext a loader can be shown instead of submit button */
    loading: PropTypes.bool,
    /** Allows direct access to the editor and set content */
    getEditorRef: PropTypes.func,
    /** Disables the submit button */
    isSubmitDisabled: PropTypes.bool,
    /** Set it to `true` if you're planning to provide a custom toolbar for the editor */
    withCustomToolbar: PropTypes.bool,
    /** Set it to `true` if you want the editor to behave like in a chat client. p.e 'Enter' submits the message */
    chatbox: PropTypes.bool,
    /** Set it to override link extension's config */
    linkConfig: PropTypes.shape({
        openOnClick: PropTypes.bool,
        autolink: PropTypes.bool,
    }),
    /** Set it to override the pre component */
    preComponent: PropTypes.node,
    /** Set it to override the top component */
    topComponent: PropTypes.node,
    /** Set it to override the bottom component */
    bottomComponent: PropTypes.node,
};
